var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8439 12.4038C10.6497 13.6397 9.39773 16.2007 9 16.9166L9 5.66658C9.34539 5.04488 10.335 3.26364 12.0264 2.05299C12.739 1.54297 13.0953 1.28797 13.5476 1.52049C14 1.75301 14 2.26627 14 3.2928L14 10.6594C14 11.2139 14 11.4912 13.8861 11.686C13.7723 11.8809 13.4628 12.0552 12.8439 12.4038Z",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 5.50463C8.42767 4.90336 6.76821 3.47533 3.98388 2.97465C2.57333 2.721 1.86805 2.59418 1.2674 3.08027C0.666748 3.56637 0.666748 4.35573 0.666748 5.93444L0.666748 11.6081C0.666748 13.0516 0.666748 13.7733 1.05225 14.224C1.43774 14.6746 2.28646 14.8272 3.98388 15.1324C5.49702 15.4045 6.67795 15.8381 7.53273 16.2737C8.37373 16.7023 8.79425 16.9167 9.00008 16.9167C9.20591 16.9167 9.62643 16.7023 10.4674 16.2737C11.3222 15.8381 12.5031 15.4045 14.0163 15.1324C15.7137 14.8272 16.5624 14.6746 16.9479 14.224C17.3334 13.7733 17.3334 13.0516 17.3334 11.6081V5.93444C17.3334 4.35573 17.3334 3.56637 16.7328 3.08027C16.1321 2.59418 14.8334 2.97465 14.0001 3.58333",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.65ccd07090afa2bd9bb4ae3555077c3d.svg";
export { ForwardRef as ReactComponent };